module.exports = __webpack_public_path__ + "static/media/team1.ff0d1f72.jpg";